export default {"src":"/customer-services/_next/static/media/tv-icon.dc712bec.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};